import { render, staticRenderFns } from "./Ask.vue?vue&type=template&id=02941ea9&"
import script from "./Ask.vue?vue&type=script&lang=js&"
export * from "./Ask.vue?vue&type=script&lang=js&"
import style0 from "./Ask.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports